import { render, staticRenderFns } from "./ShopInShopPanel.vue?vue&type=template&id=20de8382&scoped=true"
import script from "./ShopInShopPanel.vue?vue&type=script&lang=js"
export * from "./ShopInShopPanel.vue?vue&type=script&lang=js"
import style0 from "./ShopInShopPanel.vue?vue&type=style&index=0&id=20de8382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de8382",
  null
  
)

export default component.exports